import type { ReactNode } from 'react';
import { cn } from '../cn';

export interface TabItem<K extends string> {
  key: K;
  label: ReactNode;
  count?: number;
}

/** Abas controladas (o estado fica com quem usa; normalmente na URL). */
export function Tabs<K extends string>({ items, value, onChange, className }: { items: TabItem<K>[]; value: K; onChange: (key: K) => void; className?: string }) {
  return (
    <div role="tablist" className={cn('flex w-fit max-w-full gap-1 overflow-x-auto rounded-full bg-mist p-1 shadow-[inset_0_1px_2px_rgb(30_58_95/0.1)]', className)}>
      {items.map((t) => (
        <button
          key={t.key}
          role="tab"
          type="button"
          aria-selected={t.key === value}
          onClick={() => onChange(t.key)}
          className={cn(
            'whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition',
            t.key === value ? 'bg-white text-ink shadow-[0_2px_8px_-2px_rgb(30_58_95/0.3)]' : 'text-muted hover:text-ink',
          )}
        >
          {t.label}
          {t.count !== undefined && <span className="ml-1.5 rounded-full bg-brand-50 px-1.5 text-xs text-brand-700">{t.count}</span>}
        </button>
      ))}
    </div>
  );
}
